import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import SimpleModal from "../../../layouts/SimpleModal";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { login } from "src/reducers/authReducers";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  sucursalCard: {
    border: `2px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(1),
    cursor: "pointer",
    transition: "border-color 0.2s, background-color 0.2s",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.grey[100],
    },
  },
  sucursalCardSelected: {
    borderColor: theme.palette.primary.main,
    backgroundColor: "#fff5ef",
  },
}));

export default function LoginOptionsModal({ sucursales, open, setOpen, user }) {
  const classes = useStyles();
  const userInfo = useSelector((state) => state.auth.user);

  const dispatch = useDispatch();
  const initialIndex = sucursales.findIndex(
    (s) => s.refSucursal === userInfo?.sucursal?.refSucursal,
  );
  const [value, setValue] = useState(initialIndex >= 0 ? initialIndex : 0);
  const [cargando, setCargando] = useState(false);
  const navigate = useNavigate();

  const handleLogin = () => {
    const sucursal = sucursales[value];
    if (sucursal) {
      setCargando(true);
      const rol = sucursal.refRol;
      localStorage.setItem("rol", rol);
      localStorage.setItem("sucursal", sucursal.refSucursal);
      dispatch(login({ ...userInfo, sucursal: sucursal, rol: rol }));

      if (setOpen !== undefined) {
        window.location.reload();
        setOpen(false);
      } else {
        if (rol === "SUPER_ADMIN" || rol === "ADMIN") {
          navigate("/dashboard/estadisticas");
        } else {
          navigate("/dashboard/rendimiento");
        }
      }
    }
  };

  return (
    <SimpleModal
      title="Seleccionar Sucursal"
      onSubmit={handleLogin}
      showCancelButton={false}
      cargandoDatos={cargando}
      open={open}
    >
      <Typography variant="body2" color="textSecondary" gutterBottom>
        Tienes acceso a más de una sucursal. Selecciona con cuál deseas
        ingresar.
      </Typography>

      <Box mt={1}>
        {sucursales.map((s, idx) => (
          <Box
            key={idx}
            className={`${classes.sucursalCard} ${value === idx ? classes.sucursalCardSelected : ""}`}
            onClick={() => setValue(idx)}
          >
            <Typography
              variant="subtitle2"
              color={value === idx ? "primary" : "textPrimary"}
            >
              {s.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </SimpleModal>
  );
}
